import { UserService, CommonService } from '@/api'
import { getToken, setToken, removeToken, setName, getName, removeName, setAddress, removeAddress, setStatus, removeStatus, setMobile, setPermission } from '@/utils/auth'
import { resetRouter } from '@/router'
import store from '@/store'
const getDefaultState = () => {
  return {
    token: getToken(),
    name: getName() || 'User',
    avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
    status: '',
    merchantName: '',
    merchantNumber: '',
    merchantId: '',
    loginResponse: {
      token: '',
      name: '',
      adress: ''
    }
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_STATUS: (state, status) => {
    state.status = status
    setStatus(status)
  },
  SET_MERCHANT_NAME: (state, name) => {
    state.merchantName = name
  },
  SET_MERCHANT_NUM: (state, number) => {
    state.merchantNumber = number
  },
  SET_MERCHANT_ID: (state, id) => {
    state.merchantId = id
  },
  SET_ADDRESS: (state, address) => {
    state.address = address
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { accountId, password } = userInfo
    return new Promise((resolve, reject) => {
      UserService.logIn({ accountId: accountId.trim(), password: password }).then(response => {
        if(response.status) {
          const { data } = response
          commit('SET_TOKEN', data.token)
          commit('SET_NAME', data.name)
          commit('SET_ADDRESS', data.address)
          setToken(data.token)
          setMobile(data.mobile)
          setName(data.name)
          setAddress(data.address ? data.address : '')
          const permissions = data.permissions.map(_ => {
            _ = '/' + _.replace(/:/g, '/')
            return _
          })
          setPermission(JSON.stringify(permissions))
          resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      UserService.logout().then(response => {
        removeToken()
        removeName()
        removeAddress()
        removeStatus()
        commit('RESET_STATE')
        resolve(response)
      })
    })
  },
  getStatus({ commit }) {
    return new Promise((resolve, reject) => {
      CommonService.getMerchantMsg().then(response => {
        if (response.status) {
          commit('SET_STATUS', response.data.status)
          commit('SET_MERCHANT_NAME', response.data.name)
          commit('SET_MERCHANT_NUM', response.data.merchantNumber)
          commit('SET_MERCHANT_ID', response.data.id)
          resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

